import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=2cce33cf&scoped=true"
import script from "./mainPage.vue?vue&type=script&lang=js"
export * from "./mainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce33cf",
  null
  
)

export default component.exports